import React from "react";
import { ExampleInput } from "../../services/rubricAdminService";
import SolutionExampleEditor from "./SolutionExampleEditor";

interface Props {
  kind: "conversation" | "solution";
  rubricId: string;
  getToken: () => string | undefined;
  examples: ExampleInput[];
  onChange: (next: ExampleInput[]) => void;
}

const ExamplesEditor: React.FC<Props> = ({ kind, rubricId, getToken, examples, onChange }) => {
  const update = (i: number, next: ExampleInput) =>
    onChange(examples.map((e, j) => (j === i ? next : e)));
  const add = () =>
    onChange([
      ...examples,
      kind === "solution" ? { solution: { answer: "" } } : { conversationText: "" },
    ]);

  return (
    <div className="mt-2">
      <div className="form-label text-xs">Examples</div>
      {examples.map((ex, i) => (
        <div key={i} className="flex gap-2 items-start mt-1">
          <div className="flex-1">
            {kind === "conversation" ? (
              <textarea
                className="form-control h-16 text-sm"
                value={ex.conversationText ?? ""}
                onChange={(e) => update(i, { ...ex, conversationText: e.target.value })}
              />
            ) : (
              <SolutionExampleEditor
                rubricId={rubricId}
                getToken={getToken}
                value={ex.solution ?? { answer: "" }}
                onChange={(solution) => update(i, { ...ex, solution })}
              />
            )}
          </div>
          <button
            type="button"
            className="text-error text-xs"
            onClick={() => onChange(examples.filter((_, j) => j !== i))}
          >
            Remove
          </button>
        </div>
      ))}
      <button type="button" className="text-xs text-slate-400 mt-1" onClick={add}>
        + Add example
      </button>
    </div>
  );
};

export default ExamplesEditor;
